var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('circular-loader',{attrs:{"loading":_vm.loading && !_vm.transportDocument}}),(_vm.component && !_vm.loading)?_c(_vm.component,{tag:"component",attrs:{"uuid":_vm.uuid,"transportDocumentProp":_vm.transportDocument}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }